import { render, staticRenderFns } from "./o-header.vue?vue&type=template&id=632646f4&scoped=true&"
import script from "./o-header.vue?vue&type=script&lang=js&"
export * from "./o-header.vue?vue&type=script&lang=js&"
import style0 from "./o-header.vue?vue&type=style&index=0&id=632646f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632646f4",
  null
  
)

export default component.exports